import React, { useEffect, useRef, useState } from "react";
import { FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";

import "../../../assets/css/customer/contact/contactMapSocial/ContactMapSocial.css";

const ContactMapSocial = () => {
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      },
    );

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }

    return () => {
      if (wrapperRef.current) {
        observer.unobserve(wrapperRef.current);
      }
    };
  }, []);

  const socialLinks = [
    {
      icon: FaFacebookF,
      link: "https://www.facebook.com/Kisaanmart1",
      color: "#3b5998",
      label: "Facebook",
    },
    {
      icon: FaInstagram,
      link: "https://www.instagram.com/kisaan_mart1",
      color: "#e1306c",
      label: "Instagram",
    },
    {
      icon: FaEnvelope,
      link: "mailto:kisaanmart0@gmail.com",
      color: "#4CAF50",
      label: "Email",
    },
  ];

  return (
    <div
      ref={wrapperRef}
      className={`map-wrapper ${isVisible ? "animate-in" : ""}`}
    >
      {/* Google Maps */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108727.59698834022!2d74.0855!3d32.1877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391f29bc8415c039%3A0xc5f3a3f072c2e2c!2sGujranwala%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="KisaanMart Location"
        ></iframe>
      </div>

      {/* Social Links */}
      <div className="social-section">
        <h3 className="social-title">Follow Us</h3>

        <p className="social-subtitle">Stay connected with KisaanMart</p>

        <div className="social-links">
          {socialLinks.map((social, index) => {
            const Icon = social.icon;

            return (
              <a
                key={index}
                href={social.link}
                className="social-link"
                target={social.label === "Email" ? "_self" : "_blank"}
                rel={
                  social.label === "Email" ? undefined : "noopener noreferrer"
                }
                aria-label={social.label}
                title={social.label}
                style={{
                  "--hover-color": social.color,
                }}
              >
                <Icon />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ContactMapSocial;
